import service from '../utils/Service';
import {PicTypes} from '../utils/enumUtils';

const editPicture = (picType, userData, picUrl, template, event)  => {

    // eslint-disable-next-line
    switch(picType){
        case PicTypes.PROFILE:{
            let infoToSend = Object.assign({}, userData, {picUrl: picUrl});
            return {
                type: 'EDIT_PICTURE_USER',
                payload: service.editUserInfo(infoToSend, userData.id)
            };
        }
        case PicTypes.COVER:{
            let infoToSend = Object.assign({}, userData, {coverPicUrl: picUrl});
            return {
                type: 'EDIT_PICTURE_USER',
                payload: service.editUserInfo(infoToSend, userData.id)
            };
        }
        case PicTypes.LOGO:{
            let infoToSend = Object.assign({}, userData, {logoPicUrl: picUrl});
            return {
                type: 'EDIT_PICTURE_USER',
                payload: service.editUserInfo(infoToSend, userData.id)
            };
        }
        case PicTypes.TEMPLATE:{
            return {
                type: 'EDIT_PICTURE_TEMPLATE',
                payload: service.editTemplatePic(userData.id, template.objectId, picUrl)
            };
        }
        case PicTypes.EVENT_COVER:{
            return {
                type: 'EDIT_PICTURE_EVENT_COVER',
                payload: service.editEventCoverPic(userData.id, event.objectId, picUrl)
            }
        }
    }
};

export default editPicture;



// WEBPACK FOOTER //
// ./src/actions/editPictureAction.js